///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { getMatch, IPRange, IPSubnetwork, IPv4 } from 'ip-matching';

const classARange = getMatch('1.0.0.0-127.0.0.0') as IPRange;
const classBRange = getMatch('128.0.0.0-191.255.0.0') as IPRange;
const classCRange = getMatch('192.0.0.0-223.255.255.0') as IPRange;

export const validateIpBySupportedRange = (ip: string): boolean => {
    try {
        return classARange.matches(ip) || classBRange.matches(ip) || classCRange.matches(ip);
    } catch (e) {
        return false;
    }
};

export const validateIpBySubnetwork = (ip: string, startIp: string, subnetMask: number): boolean => {
    const subnetwork: IPSubnetwork = getMatch(startIp + '/' + subnetMask) as IPSubnetwork;

    try {
        const rangeIpString = `${startIp}-${subnetwork.getLast().toString()}`;
        const subnetIpsRange: IPRange = getMatch(rangeIpString) as IPRange;
        return subnetIpsRange.matches(ip) && !subnetwork.getLast().matches(ip);
    } catch (e) {
        return false;
    }
};

export const validateGateWayBySubnetwork = (ip: string, startIp: string, subnetMask: number): boolean => {
    const subnetwork: IPSubnetwork = getMatch(startIp + '/' + subnetMask) as IPSubnetwork;

    try {
        return subnetwork.matches(new IPv4(ip));
    } catch (e) {
        return false;
    }
};
